const Qs = require('qs')

/**
 * @description 绑定事件 on(element, event, handler)
 */
export const on = (function () {
  if (document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler)
      }
    }
  }
})()
/**
 * @description 解绑事件 off(element, event, handler)
 */
export const off = (function () {
  if (document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler)
      }
    }
  }
})()

/**
 * 判断类型
 * @param str
 * @return {boolean}
 */
export function isJsonString(str) {
  try {
    if (typeof JSON.parse(str) == 'object') {
      return true
    }
  } catch (e) {
    return false
  }
}

/**
 * 深拷贝
 * @param data
 * @return {{}|*}
 */
export const deepCopy = data => {
  const t = typeOf(data)
  let o
  if (t === 'array') {
    o = []
  } else if (t === 'object') {
    o = {}
  } else {
    return data
  }
  if (t === 'array') {
    for (let i = 0; i < data.length; i++) {
      o.push(deepCopy(data[i]))
    }
  } else if (t === 'object') {
    for (let i in data) {
      o[i] = deepCopy(data[i])
    }
  }
  return o
}

/**
 * 判断类型
 * @param obj
 * @return {*}
 */
export function typeOf(obj) {
  const toString = Object.prototype.toString
  const map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  }
  return map[toString.call(obj)]
}

/**
 * 循环方法
 * @param arr
 * @param fn
 */
export const forEachs = (arr, fn) => {
  if (!arr.length || !fn) return
  let i = -1
  let len = arr.length
  while (++i < len) {
    let item = arr[i]
    fn(item, i, arr)
  }
}
export const getTimes = (type, time) => {
  let T = time ? time : new Date()
  let now = new Date(T)
  let Y = now.getFullYear()
  let M = (now.getMonth() + 1) < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1
  let D = now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
  let H = now.getHours() < 10 ? '0' + now.getHours() : now.getHours()
  let m = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()
  let s = now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds()
  switch (type) {
    case 'YM':
      return `${Y}${M}`
    case 'Y-M-D-1':
      return getTimes('Y-M-D', new Date(now.getTime() - 24 * 60 * 60 * 1000))
    case 'Y-M-D':
      return `${Y}-${M}-${D}`
    case 'Y-M':
      return `${Y}-${M}`
  }
}
export const upOfDown = v => {
  let name = ''
  if (v.includes('-')) {
    name = 'td-down'
  } else if (v === 0 || v === '0%') {
    name = 'td-flat'
  } else if (v) {
    name = 'td-up'
  }
  return name
}

/**
 * 序列化参数
 * @param params
 * @return {string}
 */
export const qs = params => {
  let p = Qs.stringify(params, {arrayFormat: 'repeat'})
  return p.indexOf('?') > -1 ? p : `?${p}`
}

